export default (event, funnelName, subFunnelName) => {
  return {
    'event': event,
    'funnel_name': funnelName,
    'sub_funnel_name': subFunnelName,
  };
};